import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal, H2, Typography, Image, Button } from './index';
import { ROUTES } from '../Constants';
import { getSpacing } from '../utils';
import LovingIllustration from '../assets/images/illustrations/loving.svg';
import { finishTask, setAvailable } from '../lib/taskrouter';

const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 160px;
  justify-content: center;
  width: 100%;
  margin-bottom: ${getSpacing('large')};
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-bottom: ${getSpacing('large')};
`;

const CompletedCallModal = ({ history, executedHitsCount, maxHitsCount }) => (
  <Modal closeButton={false} padding={{ top: 'large', right: 'small', left: 'small' }}>
    <H2 fontWeight={700} margin={{ bottom: 'xs' }}>
      Thanks For Your Feedback
    </H2>
    <Typography margin={{ bottom: 'large' }}>
      You’ve officially completed this call. Ready for the next one?
    </Typography>

    <ImageContainer>
      <Image src={LovingIllustration} />
    </ImageContainer>

    <ButtonContainer>
      <Button
        theme="bordered"
        margin={{ right: 'xs' }}
        onClick={async () => {
          await finishTask();
          history.push(ROUTES.HOME);
        }}
      >
        Go to dashboard
      </Button>
      <Button
        margin={{ left: 'xs' }}
        onClick={async () => {
          await finishTask();

          if (maxHitsCount != null && executedHitsCount >= maxHitsCount) {
            history.push(ROUTES.NO_MORE_TASKS);
          } else {
            await setAvailable();
            history.push(ROUTES.JOB);
          }
        }}
      >
        Go to next call
      </Button>
    </ButtonContainer>
  </Modal>
);

CompletedCallModal.propTypes = {
  executedHitsCount: PropTypes.number.isRequired,
  maxHitsCount: PropTypes.number,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

CompletedCallModal.defaultProps = {
  maxHitsCount: null
};

export { CompletedCallModal };
